/*
 * Vista previa para el detalle de la devolución.
 *
 * Componentes correspondientes a la vista previa de los elementos que conforman
 * el contenido del detalle de la devolución.
 *
 * Created on Mon Apr 17 2023 by José Luis Chávez Ayala.
 *
 * Copyright (c) 2023 Turn My App.
 */

<template>
  <div>
    <b-skeleton
      class="mt-1"
      animation="wave"
      width="100%"
      height="100px"
    />
    <b-skeleton
      class="mt-1"
      animation="wave"
      width="100%"
      height="120px"
    />
    <b-skeleton
      class="mt-2"
      animation="wave"
      width="100%"
      height="120px"
    />
    <b-skeleton
      class="mt-2"
      animation="wave"
      width="100%"
      height="260px"
    />
  </div>
</template>

<script>
import { BSkeleton } from 'bootstrap-vue'

export default {
  components: {
    BSkeleton,
  },
  data() {
    return {
      loadingRefund: false,
    }
  },
}
</script>
